import { AppState, initialAppState } from "./app-types";

const STORAGE_KEY = "mcp-inspector-state";

export function loadAppState(): AppState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};

    return {
      servers: {}, // Servers now come from Convex, not localStorage
      selectedServer: parsed.selectedServer || "none",
      selectedMultipleServers: parsed.selectedMultipleServers || [],
      isMultiSelectMode: parsed.isMultiSelectMode || false,
    } as AppState;
  } catch (e) {
    console.error("Failed to load app state", e);
    return initialAppState;
  }
}

export function saveAppState(state: AppState) {
  try {
    // Only save UI state - servers are managed by Convex backend
    const serializable = {
      selectedServer: state.selectedServer,
      selectedMultipleServers: state.selectedMultipleServers,
      isMultiSelectMode: state.isMultiSelectMode,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(serializable));
  } catch (e) {
    console.error("Failed to save app state", e);
  }
}
